import { Injectable } from '@angular/core';
import { ExportTypeQuery } from '@y42/data-export';
import { DatasourceTypeQuery } from '@y42/datasource';
import { GitDiffTreeService as AbstractGitDiffTreeService } from '@y42/feature/git';

@Injectable({ providedIn: 'root' })
export class GitDiffTreeService extends AbstractGitDiffTreeService {
  constructor(
    private readonly datasourceTypeQuery: DatasourceTypeQuery,
    private readonly exportTypeQuery: ExportTypeQuery,
  ) {
    super();
  }

  getTypeDisplayName($schema: string): string | null {
    const model =
      this.datasourceTypeQuery.findModelBySchema($schema, { skipUnsupportedSchemaErrorLog: true }) ??
      this.exportTypeQuery.findModelBySchema($schema, { skipUnsupportedSchemaErrorLog: true });
    return model?.displayName || null;
  }

  getTypeLogo($schema: string): string | null {
    const model =
      this.datasourceTypeQuery.findModelBySchema($schema, { skipUnsupportedSchemaErrorLog: true }) ??
      this.exportTypeQuery.findModelBySchema($schema, { skipUnsupportedSchemaErrorLog: true });
    return model?.logo || null;
  }
}
